export default  
      {'Eynesbury PROJECT': require('../assets/logos/Eynesbury PROJECT.png'),
      'Findon Creek PROJECT': require('../assets/logos/Findon Creek PROJECT.png'),
      'Harvest Green PROJECT':  require('../assets/logos/Harvest Green PROJECT.png'),
      'Mernda Rise PROJECT':  require('../assets/logos/Mernda Rise PROJECT.png'),
      'Mora Townhouse PROJECT':  require('../assets/logos/Mora Townhouse PROJECT.png'),
      'Neo PROJECT':  require('../assets/logos/Neo PROJECT.png'),
      'Newbridge PROJECT':  require('../assets/logos/Newbridge PROJECT.png'),
      'Newbridge South PROJECT': require('../assets/logos/Newbridge South PROJECT.png'),
      'West Terrace PROJECT': require('../assets/logos/West Terrace PROJECT.png')
}


